(function ($) {
    $(document).ready(function () {
        let $mobile_menu = $('.mobile-menu'),
            $burger_button = $('.header__burger-menu');

        if ($mobile_menu.length < 1) {
            return;
        }

        $burger_button.on('click', function (e) {
            stopPropagation(e);
            e.preventDefault(); //Prevent scroll to top of page when opening mobile menu (Firefox)

            $('body').toggleClass('menu-open');
            // $mobile_menu.stop(true).slideToggle(600);
            // $mobile_menu.toggleClass('mobile-menu--open');
            $burger_button.toggleClass('header__burger-menu--open');
        });

        // Handle responsive opening and closing etc.
        let $submenus = $('.menu-item .submenu');

        // Don't trigger menu on clicking anchors
        $('a', $mobile_menu).on('click', stopPropagation);
        $('.main-menu .menu-item').on('click', stopPropagation);

        if ($submenus.length < 1) {
            return;
        }

        $submenus.each(function (idx, elm) {
            let $submenu = $(elm),
                $parent = $submenu.parents('.menu-item');

            // Handle clicking on parent to fold in/out
            $parent.on('click', function (evt) {
                $(this).toggleClass('menu-item--expanded').toggleClass('menu-item--collapsed');
                $(this).find('.submenu').toggle("fast");
            });

            // Collapse the menu
            $parent.removeClass('menu-item--expanded').addClass('menu-item--collapsed');

            //Default to have submenu hidden in mobile menu
            //This is so we don't have to create separate menus, but can use the same menu with different functionality
            //for the main menu & mobile menu
            $('.menu-item:not(.menu-item--active-trail) .submenu', $mobile_menu).css('display', 'none');
        });
    });

    function stopPropagation(evt) {
        evt.stopPropagation();
    }
})(jQuery);
